const Images = {
  logo: require("../assets/Logo.svg").default,
};

export default Images;
